export const StreakMeter = ({ streak }) => {
  if (!streak) return null;
  const n = streak.next;
  if (!n) return (
    <div className="mm-soft p-3 mb-4 text-sm" data-testid="plan-streak-meter">🌳 All tough-day badges earned — {streak.current} nudge day{streak.current === 1 ? "" : "s"} in a row now.</div>
  );
  return (
    <div className="mm-soft p-3 mb-4" data-testid="plan-streak-meter">
      <div className="flex items-center justify-between gap-2 text-sm">
        <span className="font-semibold">{n.icon} {n.name}</span>
        <span className="text-mm-muted" data-testid="plan-streak-progress">{n.progress} of {n.target} nudge days</span>
      </div>
      <div className="flex gap-1 mt-2" aria-label={`${n.progress} of ${n.target}`}>
        {Array.from({ length: n.target }, (_, i) => (
          <span key={i} className={`h-2 flex-1 rounded-full transition-colors duration-500 ${i < n.progress ? "bg-mm-primary" : "bg-mm-surface"}`} data-testid={`plan-streak-dot-${i}`} />
        ))}
      </div>
      <div className="text-xs text-mm-muted mt-1.5">Finish your plan on nudge days in a row to earn it.</div>
    </div>
  );
};
